
import { mapGetters, mapActions } from 'vuex'
export default {
  beforeRouteLeave(to, from, next) {
    if (from.path === '/agendamento') {
      this.fullyCleanCart()
    }
    next()
  },
  middleware: 'checkPayment',
  data() {
    return {
      e1: 1,
      cnh: false,
      urlContato: `${window.location.origin}/contato`,
      emitiuCertificado: false,
      rules: [(v) => !!v || 'Campo obrigatório'],
      registerBuyer: {
        cpfCnpj: '',
        arquivoCNH: '',
        arquivoSocial: '',
        tipoAgenda: '',
        sitePedido: this.$route.query.idTransacao,
      },
      productRadios: null,
      idProduct: '',
    }
  },
  head() {
    return {
      title: 'Agendamento em Curitiba Certificado digitais',
    }
  },
  computed: {
    ...mapGetters('dataClient', ['allDataClient', 'allCartClient']),
    showContratoSocialUpload() {
      const cpfCnpj = this.registerBuyer.cpfCnpj.replace(/\D/g, '')
      return cpfCnpj.length === 14
    },
  },

  methods: {
    ...mapActions('dataClient', ['cleanClient', 'fullyCleanCart']),
    handleAdvance() {
      // if (this.allDataClient.length !== 0) {
      //   return this.$toast.error(
      //     'Escolha a opção que indica se o agendamento é para você ou para outra pessoa.'
      //   )
      // }
      const validate = this.$refs.formRegisterBuyer.validate()
      if (!validate) {
        return false
      }
      if (!this.productRadios) {
        return this.$toast.error('Selecione produto para agendamento!')
      }
      if (
        this.registerBuyer.tipoAgenda === 'Videoconferencia' &&
        !this.cnh &&
        !this.emitiuCertificado
      ) {
        return this.$toast.warning(
          'Para videoconferência, é necessário CNH ou ter emitido um certificado; caso contrário, somente presencial.'
        )
      }
      this.e1 = 2
      this.registerBuyer.produtoEmissao = this.productRadios.descricao
      this.registerBuyer.valor = this.productRadios.precoUnitario
      this.registerBuyer.sku = this.productRadios.sku
      this.idProduct = this.productRadios.id
      this.toScroll()
    },
    handleAdvanceUpload() {
      // const doc = this.registerBuyer.arquivoCNH
      // const cSocial = this.registerBuyer.arquivoSocial
      // if (!doc && !cSocial) {
      //   return this.$toast.error(
      //     'Upload do documento ou contrato social obrigatório'
      //   )
      // }
      this.e1 = 3
    },
    UploadSuccessDoc(response) {
      this.registerBuyer.arquivoCNH = response.id
    },
    UploadSuccessCsocial(response) {
      this.registerBuyer.arquivoSocial = response.id
    },
    moreAgenda() {
      this.e1 = 1
      this.cnh = false
      this.emitiuCertificado = false
      this.registerBuyer.nome = ''
      this.registerBuyer.email = ''
      this.registerBuyer.cpfCnpj = ''
      this.registerBuyer.telefone = ''
      this.registerBuyer.arquivoCNH = ''
      this.registerBuyer.arquivoSocial = ''
      this.registerBuyer.tipoAgenda = ''
      this.$refs.formRegisterBuyer.resetValidation()
      if (this.$refs.refDoc && this.$refs.refDoc.$refs.refDropzone) {
        this.$refs.refDoc.$refs.refDropzone.removeAllFiles()
      }
      if (
        this.$refs.refContratoSocial &&
        this.$refs.refContratoSocial.$refs.refDropzone
      ) {
        this.$refs.refContratoSocial.$refs.refDropzone.removeAllFiles()
      }
    },
    YesClientData() {
      this.registerBuyer.nome = this.allDataClient.nome
      this.registerBuyer.email = this.allDataClient.email
      this.registerBuyer.cpfCnpj = this.allDataClient.cpfCnpj
      this.registerBuyer.telefone = this.allDataClient.telefone
      this.cleanClient()
    },
    toScroll() {
      const top = window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
      return top
    },
  },
}
